import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ResellerPayment, paymentTypeMap } from "../../../core/models/reseller-statement.model";
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from "@angular/material";
import { AuthNoticeService } from "../../../core/auth";
import { NgxDropzoneComponent } from "ngx-dropzone";
import { CollectionService } from "../../../core/services/collection.service";
import { LayoutUtilsService, MessageType } from "../../../core/_base/crud";
import { UIPermissionWrapper } from "../../../model/ui-permission-wrapper.model";
import { FrontendService } from "../../../service/frontend.service";

export interface DialogData {
	campaign: string;
	debt: any;
	paymentsData: ResellerPayment[];
}

@Component({
	selector: "kt-dialog-payment",
	templateUrl: "./dialog-payment-list.component.html",
	styleUrls: ["./dialog-payment-list.component.scss"]
})
export class DialogPaymentListComponent implements OnInit {

	@ViewChild("dropzone") public dropzone: NgxDropzoneComponent;
	public campaign: string;
	public displayedColumns: string[] = [
		"id", "campaign", "date", "amount",	"type",
		"entity", "actions"
	];
	public error: boolean = false;
	public isLoading: boolean;
	public paymentTypeMap = paymentTypeMap;
	public resellerPayments = [];

	// Monto total facturado en campaña:
	public invoicedAmount: number = undefined;

	// Wrapper de permisos de UI:
	public permission: UIPermissionWrapper;

	constructor(
		private frontendService: FrontendService,
		private authNoticeService: AuthNoticeService,
		private collectionService: CollectionService,
		private layoutUtilsService: LayoutUtilsService,
		private snackBar: MatSnackBar,
		public dialogRef: MatDialogRef<DialogPaymentListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

	public ngOnInit(): void {
		this.permission = this.frontendService
            .permissionFor("views/shared/dialog-payment-list/dialog-payment-list.component");
		this.invoicedAmount = this.data.debt.dueAmount;
		this.authNoticeService.setNotice(null);
		this.initPayments();
	}

	public deletePayment(paymentId: any) {
		const _title: string = "Eliminar pago";
		const _description: string = "¿Está seguro que desea eliminar este pago?";
		const _waitDesciption: string = "Eliminando...";
		const _deleteMessage = `El pago ha sido eliminado`;
		this.layoutUtilsService
			.deleteElement(_title, _description, _waitDesciption)
			.afterClosed()
			.subscribe({
				next: res => {
					if (!res) {
						return;
					}
					else {
						this.collectionService
							.deletePayment(paymentId)
							.subscribe({
								next: _ => {
									this.layoutUtilsService
										.showActionNotification(_deleteMessage, MessageType.Delete, 5000, true, false);
									this.dialogRef.close(true);
								},
								error: error => {
									this.snackBar.open(error.error, "OK", { duration: 5000 });
								}
							});
					}
				},
				error: (error: Error) => console.error(error)
			});
	}

	public onNoClick(): void {
		this.dialogRef.close(false);
	}

	public prepareJSON(data: any): any {
		data.resellerPayments = this.resellerPayments;
		return data;
	}

	private initPayments(): void {
		this.resellerPayments = this.data.paymentsData;
		this.campaign = this.data.campaign;
	}

	public isCorrectPaymentType(paymentType: number): boolean {
		switch (paymentType) {
			case 11:
			case 8:
				return false;
			default:
				return true;
		}
	}
}
